export default __webpack_public_path__ + "static/banner-1-1-99f20df29c2cd2aaa99878646eec8cdd.jpg";